// prettier-ignore
export const inputOnOffValues = [
    0xF420, // 62496
    0xF421, // 62497
    0xF422, // 62498
    0xF423, // 62499
    0xF424, // 62500
    0xF425, // 62501
    0xF426, // 62502
    0xF427, // 62503
    0xF428, // 62504
    0xF429, // 62505
    0xF42A, // 62406
    0xF42B, // 62407
    0xF42C, // 62408
    0xF42D, // 62409
    0xF42E, // 62510
    0xF42F, // 62511
    0xF430, // 62512
    0xF431, // 62513
    0xF432, // 62514
    0xF433, // 62515
    0xF434, // 62516
    0xF435, // 62517
    0xF436, // 62518
    0xF437, // 62519
    0xF438, // 62520
    0xF439, // 62521
    0xF43A, // 62522
    0xF43B, // 62523
    0xF43C, // 62524
    0xF43D, // 62525
    0xF43E, // 62526
    0xF43F, // 62527

    0xF440, // 62528
    0xF441, // 62529
    0xF442, // 62530
    0xF443, // 62531
    0xF444, // 62532
    0xF445, // 62533
    0xF446, // 62534
    0xF447, // 62535
    0xF448, // 62536
    0xF449, // 62537
    0xF44A, // 62538
    0xF44B, // 62539
    0xF44C, // 62540
    0xF44D, // 62541
    0xF44E, // 62542
    0xF44F, // 62543
    0xF450, // 62544
    0xF451, // 62545
    0xF452, // 62546
    0xF453, // 62547
    0xF454, // 62548
    0xF455, // 62549
    0xF456, // 62550
    0xF457, // 62551
    0xF458, // 62552
    0xF459, // 62553
    0xF45A, // 62554
    0xF45B, // 62555
    0xF45C, // 62556
    0xF45D, // 62557
    0xF45E, // 62558
    0xF45F, // 62559
  ];
